import React from 'react';
import { TwoColumnLayout, Column } from '../../components/TwoColumnLayout';
import { Row, Column as FoundationColumn } from 'react-foundation';
import { PageHeader } from '../../components/PageHeader';
import { Button } from '../../components/Button';
import styled from 'styled-components';
import { UserInfo } from './PageSections/UserInfo';
import { DeliveryInfo } from './PageSections/DeliveryInfo';
import { PasswordInfo } from './PageSections/PasswordInfo';
import { PaymentInfo } from './PageSections/PaymentInfo';
import { ProcuristInfo } from './PageSections/ProcuristInfo';
import { MarketingPermission } from './PageSections/MarketingPermission';
import { CompanyInfo } from './PageSections/CompanyInfo';
import { CreditCardInfo } from './PageSections/CreditCardInfo';
import { CustomerValues } from './CustomerValues';

interface Props {
	accountType: string;
	submitCustomerData: () => void;
	customerDataSubmitted: boolean;
	customerUpdateFinished: boolean;
	customerValues: CustomerValues;
	customerContactData: any;
	handleCustomerDataChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	customerDeliveryData: any;
	marketingAllowed: boolean;
	handleMarketingChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	phoneDirectoryOwnerData: any;
	phoneDirectoryOwnerDataChangeHandler: (field: string, value: string) => void;
	customerBillingData: any;
	customerProcuraData: any;
}

const SuccessNotice = styled.div`
	margin: auto;
	text-align: center;
	color: #93cb13;
	margin-bottom: 2em;
`;

export const CustomerInfoPageContent: React.FC<Props> = (props: Props) => {
	return (
		<div>
			<PageHeader>Asiakastiedot</PageHeader>
			{props.customerDataSubmitted && props.customerUpdateFinished && (
				<SuccessNotice>
					<span>Tiedot päivitetty onnistuneesti</span>
				</SuccessNotice>
			)}
			{props.accountType === 'consumer' && (
				<Row>
					<FoundationColumn large={12} medium={12} small={12}>
						<UserInfo accountType={props.accountType} customerValues={props.customerValues} customerContactData={props.customerContactData} handleCustomerDataChange={props.handleCustomerDataChange} />
						<DeliveryInfo
							accountType={props.accountType}
							customerDeliveryData={props.customerDeliveryData}
							customerValues={props.customerValues}
							handleCustomerDataChange={props.handleCustomerDataChange}
						/>
						<Button onClick={props.submitCustomerData}>Lähetä tiedot</Button>
						<PasswordInfo accountType={props.accountType} />
						<CreditCardInfo accountType={props.accountType} />
						<MarketingPermission handleMarketingChange={props.handleMarketingChange} marketingAllowed={props.marketingAllowed} narrowStyles={true} />
						<Button onClick={props.submitCustomerData}>Lähetä tiedot</Button>
					</FoundationColumn>
				</Row>
			)}
			{props.accountType === 'business' && (
				<TwoColumnLayout>
					<Column>
						<UserInfo accountType={props.accountType} customerValues={props.customerValues} customerContactData={props.customerContactData} handleCustomerDataChange={props.handleCustomerDataChange} />
						<PasswordInfo accountType={props.accountType} />
						<CompanyInfo phoneDirectoryOwnerData={props.phoneDirectoryOwnerData} phoneDirectoryOwnerDataChangeHandler={props.phoneDirectoryOwnerDataChangeHandler} />
					</Column>
					<Column>
						<DeliveryInfo
							accountType={props.accountType}
							customerDeliveryData={props.customerDeliveryData}
							customerValues={props.customerValues}
							handleCustomerDataChange={props.handleCustomerDataChange}
						/>
						<PaymentInfo customerBillingData={props.customerBillingData} />
						<ProcuristInfo customerProcuraData={props.customerProcuraData} />
					</Column>
				</TwoColumnLayout>
			)}
		</div>
	);
};
